module.exports = __webpack_public_path__ + "static/ClickedTripPostponed-e450da54bf9f1571aea216262cde2d9f.png";